import React from 'react';
import Review from './Review'
import { AboutUS } from '../../assets/images/index';
import { motion } from 'framer-motion'
import {Bharat}from '../../assets/icons/index'

const AboutUs = () => {

    const splitTextArray = (text) => {
        return text.split("").map((char, index) => (
            <motion.span
                key={index}
                initial={{ opacity: 0, y: -10 }} // Start slightly above
                animate={{ opacity: 1, y: 0 }}   // Animate to normal position
                transition={{
                    delay: index * 0.05, // Faster staggered effect for characters
                    duration: 0.3,
                    ease: "easeOut",
                }}
                className="inline-block"
            >
                {char === " " ? "\u00A0" : char} {/* Preserve spaces */}
            </motion.span>
        ));
    };

    return (
        <div>
            <motion.div
                className="bg-cover bg-center bg-no-repeat w-full h-screen min-h-[300px] backdrop-blur-sm"
                style={{
                    backgroundImage: `url(${AboutUS})`,
                    backgroundSize: 'cover', // Cover the entire container (ensure the image always covers the space)
                    backgroundPosition: 'center', // Keep the image centered
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                whileInView={{ opacity: 1, y: 0 }} // Slide in from the top when in view
                viewport={{ once: true }} // Triggers animation when in view
            >
                <div className="flex justify-center items-center my-auto flex-col gap-[15px] fontText">
                    <div className="font-semibold text-[65px] text-[#ffffff] mt-[200px] max-md:text-[42px]">
                        {splitTextArray('About us')}
                    </div>
                </div>
            </motion.div>

            <motion.div
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 3, delay: 1 }}
                              whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                              viewport={{ once: true }}
                               className='container flex flex-col justify-center items-center py-[100px]'>
                <div>
                    <h4 className='fontText text-[32px] font-semibold mb-[30px]'>
                        {splitTextArray('Shree Dattguru Enterprise')}
                        </h4>
                </div>
                <div className='flex flex-col gap-[20px] items-center max-md:px-[20px]'>
                    <h5 className='fontText text-[18px] font-normal text-center'>
                   With over 15 years of experience in the construction industry, <strong>Shree Dattguru Enterprise</strong>, founded on <b>21st April 2010</b>, is a trusted name in delivering exceptional civil services. Our dedication to quality and customer satisfaction has earned us the trust of over 10 national clients. We pride ourselves on a highly skilled workforce of more than 300 laborers who bring expertise and dedication to every project.
                    </h5>
                    <h5 className='fontText text-[18px] font-normal text-center'>
                        We offer a comprehensive range of civil works, ensuring that all aspects of construction are covered, from initial design to final completion. Our team is committed to maintaining the highest standards of safety, efficiency, and craftsmanship on every project, making us a leading choice for clients looking for reliable and professional construction services.
                    </h5>
                </div>
            </motion.div>

            <motion.div className='container '>
                <div className='flex flex-col justify-center items-center mb-[50px]'>
                   <div className="rounded-[15px] w-full max-w-[555px] h-auto">
  <img src={Bharat} alt="Bharat" className="w-full h-auto rounded-[15px] object-cover" />
</div>
                    <div className='flex flex-col item-centers'>
                        <h4 className='fontText text-[24px] font-normal'>
                            Bharat Suthar
                        </h4>
                        <h4 className='fontText text-[16px]'>
                            ( Founder & Director )
                        </h4>
                    </div>
                </div>
            </motion.div>
            <div className="container pb-[100px]">
                <div>
                    <h4 className='fontText text-[32px] text-center font-semibold mb-[30px]'>
                        {splitTextArray('What our customer says ?')}
                    </h4>
                </div>
                <Review />
            </div>
        </div>
    );
};

export default AboutUs;
